module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/layout/layout-top-panel-6-a7c0a166134318b6e6c7f8c7d3c19011.svg";